type PartialBy<T, K extends keyof T> = Omit<T, K> & Partial<Pick<T, K>>

export type SessionAttributes = {
  visitorId: string
  stylePreference: 'women' | 'men' | undefined
  customerType: 'firstTime' | 'repeat'
  sessionId: string
}

export const sessionStorageKeys = {
  landingPage: '@figs:landing-page',
  deprecatedFeatureFlags: '@figs:features',
  usedLocales: '@figs:used-locales',
  discount: '@figs:discount',
} as const

export const convertCookiesToSessionAttributes = ({
  stylePreferenceCookie,
  initialSessionCookie,
  sessionIdCookie,
  visitorIdCookie,
}: {
  stylePreferenceCookie: string | undefined
  initialSessionCookie: string | undefined
  sessionIdCookie: string | undefined
  visitorIdCookie: string | undefined
}): PartialBy<SessionAttributes, 'sessionId' | 'visitorId'> => {
  return {
    stylePreference: stylePreferenceCookie as 'men' | 'women' | undefined,
    customerType: initialSessionCookie === 'true' ? 'firstTime' : 'repeat',
    sessionId: sessionIdCookie,
    visitorId: visitorIdCookie,
  }
}
